// const cloudurl = "http://35.154.4.154/urxpert_gowtham/";
const cloudurl = process.env.REACT_APP_STYLE_BASEURL;

export default {
  cloudurl,
};
